import React from "react";
import classNames from "classnames";

import { LayoutAlign, LayoutJustify, SpaceStep } from "./layout.types";
import styles from "./FlexLayout.module.scss";

export interface FlexLayoutProps extends React.ComponentPropsWithoutRef<"div"> {
    as?: React.ElementType;
    gap?: SpaceStep;
    padding?: SpaceStep;
    paddingInline?: SpaceStep;
    paddingBlock?: SpaceStep;
    align?: LayoutAlign;
    justify?: LayoutJustify;
    wrap?: boolean;
}

interface FlexLayoutInternalProps extends FlexLayoutProps {
    direction: "row" | "column";
}

/**
 * @purpose Internal flex container behind VStack and HStack — use those instead.
 */
export const FlexLayout = ({
    as: Component = "div",
    direction,
    gap,
    padding,
    paddingInline,
    paddingBlock,
    align,
    justify,
    wrap = false,
    className,
    ...props
}: Readonly<FlexLayoutInternalProps>) => (
    <Component
        className={classNames(styles.flexLayout, className)}
        data-direction={direction}
        data-gap={gap}
        data-padding={padding}
        data-padding-inline={paddingInline}
        data-padding-block={paddingBlock}
        data-align={align}
        data-justify={justify}
        data-wrap={wrap ? "" : undefined}
        {...props}
    />
);
